function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { BOS, HALIFAX, LLOYDS, MBNA, SCOTTISH_WIDOWS, WHITE_LABEL_DARK, WHITE_LABEL_LIGHT } from "../../constants";
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24 3l-3.12-3L12 8.76 3.12 0 0 3l8.88 9L0 20.76 3.12 24 12 15l8.88 9L24 20.76 15.12 12z",
    fillRule: "evenodd"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,0.585786438 L23.4142136,2 L13.4137864,11.9997864 L23.4142136,22 L22,23.4142136 L11.9997864,13.4137864 L2,23.4142136 L0.585786438,22 L10.5857864,11.9997864 L0.585786438,2 L2,0.585786438 L11.9997864,10.5857864 L22,0.585786438 Z",
    fill: "currentColor"
  })));
};
HalifaxIcon.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var LloydsIcon = function LloydsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24 3l-3.12-3L12 8.76 3.12 0 0 3l8.88 9L0 20.76 3.12 24 12 15l8.88 9L24 20.76 15.12 12z",
    fillRule: "evenodd"
  }));
};
LloydsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var MaterialIcon = function MaterialIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M24 22.5882L22.5883 24L12 13.4118L1.41177 24L4.24341e-05 22.5882L10.5882 12L-9.87363e-07 1.41177L1.41177 -6.17103e-08L12 10.5882L22.5883 -3.34123e-05L24 1.41173L13.4118 12L24 22.5882Z",
    fill: "currentColor"
  }));
};
MaterialIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MbnaIcon = function MbnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.0024541,9.54895799 L20.9855437,0.513589808 C21.6703258,-0.173464149 22.7809675,-0.173464149 23.4759702,0.52729662 C24.1675661,1.22291733 24.1607523,2.35544269 23.4878943,3.03221653 L14.5686925,12.0033251 L23.4878943,20.9744336 C24.1726764,21.6632009 24.1726764,22.7803061 23.4759702,23.4793535 C22.7843744,24.1749742 21.6584018,24.1681208 20.9855437,23.491347 L11.9975459,14.451042 L3.01445626,23.4864102 C2.32967415,24.1734641 1.21903252,24.1734641 0.524029788,23.4727034 C-0.167566072,22.7770827 -0.16075232,21.6445573 0.512105722,20.9677835 L9.43130751,11.9966749 L0.512105722,3.02556641 C-0.172676386,2.3367991 -0.172676386,1.21969391 0.524029788,0.520646496 C1.21562565,-0.174974219 2.34159822,-0.168120813 3.01445626,0.508653036 L12.0024541,9.54895799 Z"
  }));
};
MbnaIcon.defaultProps = {
  fill: "currentColor",
  fillRule: "evenodd",
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var ScottishWidowsIcon = function ScottishWidowsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0607 3.06066C23.6464 2.47487 23.6464 1.52513 23.0607 0.93934C22.4749 0.353553 21.5251 0.353553 20.9393 0.93934L12 9.87868L3.06066 0.93934C2.47488 0.353553 1.52513 0.353553 0.939342 0.93934C0.353556 1.52513 0.353556 2.47487 0.939342 3.06066L9.87868 12L0.93934 20.9393C0.353553 21.5251 0.353553 22.4749 0.93934 23.0607C1.52513 23.6464 2.47487 23.6464 3.06066 23.0607L12 14.1213L20.9393 23.0607C21.5251 23.6464 22.4749 23.6464 23.0607 23.0607C23.6465 22.4749 23.6465 21.5251 23.0607 20.9393L14.1213 12L23.0607 3.06066Z",
    fill: "currentColor"
  }));
};
ScottishWidowsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { useTheme } from 'styled-components';
export default function (_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = useTheme() || {};
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.close) {
    var _theme$assets2, _theme$assets2$icons;
    svg = (_theme$assets2 = theme.assets) === null || _theme$assets2 === void 0 ? void 0 : (_theme$assets2$icons = _theme$assets2.icons) === null || _theme$assets2$icons === void 0 ? void 0 : _theme$assets2$icons.close;
  } else {
    switch (brand) {
      case BOS:
        svg = BosIcon;
        break;
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS:
        svg = LloydsIcon;
        break;
      case MBNA:
        svg = MbnaIcon;
        break;
      case SCOTTISH_WIDOWS:
        svg = ScottishWidowsIcon;
        break;
      case WHITE_LABEL_DARK:
      case WHITE_LABEL_LIGHT:
        svg = MaterialIcon;
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn("Icon is not available in brand \"".concat(brand, "\"."));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}